import { render, staticRenderFns } from "./OfficeDetail.vue?vue&type=template&id=1935b6c6&scoped=true&"
import script from "./OfficeDetail.vue?vue&type=script&lang=js&"
export * from "./OfficeDetail.vue?vue&type=script&lang=js&"
import style0 from "./OfficeDetail.vue?vue&type=style&index=0&id=1935b6c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1935b6c6",
  null
  
)

export default component.exports